export const buildAnswerViewModel = ({
  isMultiSelect,
  hasValidAnswer,
  paddedAnswers = [],
}) => {
  //  No valid answer at all
  if (!hasValidAnswer) {
    return isMultiSelect ? [{ isNA: true }, { isNA: true }] : [{ isNA: true }];
  }

  //  Multi select → always return exactly 2 items
  if (isMultiSelect) {
    const normalized = paddedAnswers.slice(0, 2);

    while (normalized.length < 2) {
      normalized.push({ isNA: true });
    }

    return normalized;
  }

  //  Single select → return first only
  return [paddedAnswers[0] || { isNA: true }];
};

// Professor UI

export function getChoiceLabel(question, choiceId) {
  if (!Array.isArray(question.choiceVOList)) return "";

  const match = question.choiceVOList.find((opt) => opt.choiceId === choiceId);

  return match?.label?.replace(/[\])}[{(]/g, "") || "";
}

export const getDisplayAnswers = (question) => {
  const answers =
    question.UserSelectedAnswerList ??
    question.UserSelectedanswerList ??
    [];

  const isMulti =
    question.itemTypeName === "Multi Select Question";

  // ✅ FILTER only valid answered options
  const validAnswers = answers.filter(
    (a) => typeof a.choice === "string" && a.choice.trim() !== ""
  );

  // ⛔ NOT ANSWERED (REAL CONDITION)
  if (validAnswers.length === 0) {
    return isMulti
      ? [{ type: "na" }, { type: "na" }]
      : [{ type: "na" }];
  }

  const mapAnswer = (a) => ({
    type: "answer",
    label: a.choice,
    correct: a.correct,
  });

  // ✅ MULTI SELECT
  if (isMulti) {
    if (validAnswers.length === 1) {
      return [mapAnswer(validAnswers[0]), { type: "na" }];
    }
    return validAnswers.map(mapAnswer);
  }

  // ✅ MCQ
  return [mapAnswer(validAnswers[0])];
};

export const MAX_SELECTION = 2
export const CHECKBOX = 'Multi Select Question'

export const getQuestionStatus = (ques) => {
  const answers = ques.SelectedAnswerList?.filter(Boolean) || [];

  if (answers.length === 0) return "Unanswered";

  if (ques.itemTypeName === CHECKBOX && answers.length === 1) {
    return "Partially Answered";
  }

  return "Answered";
};